<script>
    import FieldError from './FieldError.vue';
    import Choices from 'choices.js';
    import _ from 'lodash';

    export default {
        props: {
            /**
             * Form url
             */
            url: {
                type: String,
                required: true
            },

            /**
             * Request method
             */
            method: {
                type: String,
                required: true
            },

            /**
             * Initial Values
             */
            initialValues: {
                type: Object
            },
        },

        components: {
            'field-error': FieldError
        },

        data: () => ({
            form: {},
            form_errors: [],
            is_submitted: false,
            choices_instances: []
        }),

        created() {
            // set initial values
            if (this.initialValues) {
                for (let key in this.initialValues) {
                    if (this.initialValues.hasOwnProperty(key) && this.form.hasOwnProperty(key) && this.initialValues[key] !== null) {
                        this.form[key] = this.initialValues[key];
                    }
                }
            }
        },
        methods: {
            /**
             * Send form data
             *
             * @returns void
             */
            sendData: async function() {
                if (this.is_submitted === false) {

                    // set flag and clean form errors
                    this.is_submitted = true;
                    this.cleanErrors();

                    let success = false;
                    let message = '';
                    let data = {};

                    try {
                        let result = await axios({
                            method: this.method,
                            url: this.url,
                            data: this.form
                        });

                        if (result.status === 200 && result.data) {

                            // check redirect
                            if (result.data.redirect !== undefined && result.data.redirect) {
                                window.location.replace(result.data.redirect);
                                return;
                            }

                            // check return value
                            if (result.data.success === true) {
                                success = true;
                            }

                            // return message
                            if (result.data.message !== undefined && result.data.message.length) {
                                message = result.data.message
                            }
                            // return default message
                            else {
                                message = success ? 'Formulář byl úspěšně odeslán.' : 'Došlo k chybě při odesílání formuláře.';
                            }

                            data = _.omit(result.data, ['message', 'success', 'redirect']);
                        }
                    }
                    catch(e) {
                        if (e.response.data.errors) {
                            message = 'Formulář se nepodařilo odeslat, protože položky nejsou správně vyplněny.';
                            this.form_errors = e.response.data.errors;
                        }
                        else {
                            message = 'Došlo k chybě při odesílání formuláře.';
                            console.log(e.message);
                        }
                    }
                    // reset flag
                    this.is_submitted = false;

                    // return status
                    return {
                        success: success,
                        message: message,
                        data: data
                    };
                }
            },

            /**
             * Push form error
             *
             * @param name
             * @param message
             */
            pushError: function(name, message) {
                if (this.form_errors[name] && Array.isArray(this.form_errors[name])) {
                    this.form_errors[name].push(message);
                }
                else {
                    this.form_errors[name] = [message];
                }
            },

            /**
             * Clean form from error
             *
             * @param name
             * return void
             */
            cleanError: function(name) {
                this.form_errors = _.omit(this.form_errors, name);
            },

            /**
             * Clean form errors
             *
             * return void
             */
            cleanErrors: function() {
                this.form_errors = [];
            },

            /**
             * Get choice instance by element
             *
             * @param element
             * @return Choices|null
             */
            getChoicesInstanceByElement: function(element) {
                for (let choice of this.choices_instances) {
                    if (choice.passedElement.element === element) {
                        return choice;
                    }
                }
                return null;
            }
        },

        mounted() {
            const choicesSingle = this.$el.querySelectorAll('.k-choices--single');
            for (let choice of choicesSingle) {
                this.choices_instances.push(
                    new Choices(choice, {
                        placeholder: true,
                        classNames: {
                            containerInner: 'choices__inner k-choices__inner',
                            placeholder: 'choices__placeholder k-choices__placeholder',
                            listSingle: 'k-choices__list--single choices__list--single',
                            list: 'k-choices__list choices__list'
                        },
                        loadingText: 'Načítání...',
                        noResultsText: 'Žádné výsledky nenalezeny.',
                        noChoicesText: 'Žádné možnosti k výběru',
                        itemSelectText: 'Stiskem vyberte',
                        addItemText: (value) => {
                            return `Stiskem Enter přidat <b>"${value}"</b>`;
                        },
                        maxItemText: (maxItemCount) => {
                            return `Pouze ${maxItemCount} hodnot může být přidáno`;
                        },
                    })
                );

            }


            const textChoices = this.$el.querySelectorAll('.k-choices--text');
            for (let choice of textChoices) {
                this.choices_instances.push(
                    new Choices(choice, {
                        delimiter: ',',
                        editItems: true,
                        removeItemButton: true,
                        placeholder: true,
                        classNames: {
                            containerInner: 'choices__inner k-choices__inner',
                            inputCloned: 'choices__input--cloned k-choices__input--cloned',
                            list: 'k-choices__list',
                            listItems: 'k-choices__list--multiple', //listItems: 'choices__list--multiple k-choices__item--selectable',
                            item: 'choices__item',
                            placeholder: 'choices__placeholder k-choices__placeholder',
                            item: 'choices__item k-choices__item'
                        },
                        loadingText: 'Načítání...',
                        noResultsText: 'Žádné výsledky nenalezeny.',
                        noChoicesText: 'Žádné možnosti k výběru',
                        itemSelectText: 'Stiskem vyberte',
                        addItemText: (value) => {
                            return `Stiskem Enter přidat <b>"${value}"</b>`;
                        },
                        maxItemText: (maxItemCount) => {
                            return `Pouze ${maxItemCount} hodnot může být přidáno`;
                        },
                    })
                );
            }

            const multipleChoices = this.$el.querySelectorAll('.k-choices--multiple');
            for (let choice of multipleChoices) {
                this.choices_instances.push(
                    new Choices(choice, {
                        removeItemButton: true,
                        placeholder: false,
                        searchEnabled: false,
                        searchChoices: false,
                        classNames: {
                            containerInner: 'choices__inner k-choices__inner',
                            inputCloned: 'choices__input--cloned k-choices__input--cloned',
                            list: 'k-choices__list',
                            listItems: 'k-choices__list--multiple', //listItems: 'choices__list--multiple k-choices__item--selectable',
                            item: 'choices__item k-choices__item',
                        },
                        loadingText: 'Načítání...',
                        noResultsText: 'Žádné výsledky nenalezeny.',
                        noChoicesText: 'Žádné možnosti k výběru',
                        itemSelectText: 'Stiskem vyberte',
                        addItemText: (value) => {
                            return `Stiskem Enter přidat <b>"${value}"</b>`;
                        },
                        maxItemText: (maxItemCount) => {
                            return `Pouze ${maxItemCount} hodnot může být přidáno`;
                        },
                    })
                );
            }
        }
    }
</script>
